import { useTranslation } from 'react-i18next';
import './style.scoped.css';
import Button, { ButtonTypes, ButtonSizes } from 'src/components/Button';
import InsurancePackage from 'src/models/InsurancePackage';

interface InsuranceItemProps {
  data: InsurancePackage;
  image?: string;
  isChoosed: boolean;
  onChoose: (item: InsurancePackage) => void;
}
const InsuranceItem = (props: InsuranceItemProps) => {
  const { onChoose, isChoosed = false, data } = props;
  const { t } = useTranslation();

  const _handleChoose = () => {
    if (onChoose) {
      onChoose(data);
    }
  };

  if (isChoosed) {
    return (
      <div className="itemContainerChoosed" onClick={_handleChoose}>
        <div className="mb-4 flex items-center">
          <img src={data.photo} className="image" />
          <div className="flex flex-col justify-center">
            <div className="benefitTextChoosed">{data.insamountTxt}</div>
            <div className="feeText1">{t('annual_fee')}</div>
            <div className="feeText2Choosed mb-2">{data.premiumAmTxt}</div>
          </div>
        </div>
        <Button
          buttonType={ButtonTypes.primaryFilled}
          text={t('choosed')}
          onClick={_handleChoose}
          size={ButtonSizes.small}
          extraClassName={'w-full'}
        />
      </div>
    );
  }

  return (
    <div className="itemContainer" onClick={_handleChoose}>
      <div className="mb-4 flex items-center">
        <img src={data.photo} className="image" />
        <div className="flex flex-col justify-center">
          <div className="benefitText">{data.insamountTxt}</div>
          <div className="feeText1">{t('annual_fee')}</div>
          <div className="feeText2 mb-2">{data.premiumAmTxt}</div>
        </div>
      </div>
      <Button
        buttonType={ButtonTypes.primaryBorderless3}
        text={t('choose_now')}
        onClick={_handleChoose}
        size={ButtonSizes.small}
        extraClassName={'w-full'}
      />
    </div>
  );
};
export default InsuranceItem;
